import styled from 'styled-components'

const TitleListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--gap-16);
`

export default TitleListStyled
